<template>
  <Component :is="props.tag">
    <span class="whitespace-pre-line">{{ props.content }}</span>
  </Component>
</template>

<script setup lang="ts">
interface PayloadTextAreaProps {
  content: string
  tag?: keyof HTMLElementTagNameMap
}

const props = withDefaults(defineProps<PayloadTextAreaProps>(), { tag: 'p' })
</script>
